import dayjs from "dayjs"
import ExcelJS from "exceljs"
import saveAs from "file-saver"

export const studentStudyExcel = async (panel, level, year = 'ทั้งหมด') => {
  const common_format = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  }

  const middle_center = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  }

  const middle_left_no_wrap = {
    vertical: "middle",
    horizontal: "left"
  }

  // const middle_left = {
  //   vertical: "middle",
  //   horizontal: "left",
  //   wrapText: true
  // }

  const middle_right = {
    vertical: "middle",
    horizontal: "right",
    wrapText: true
  }

  const workbook = new ExcelJS.Workbook()
  workbook.creator = "Registrar KMITL"
  workbook.created = new Date()

  panel.map((value) => {
    if (value.OFFICIAL_FACULTY_ID == null) {
        value.OFFICIAL_FACULTY_ID = "90"
    }
    const OFFICIAL_FACULTY_ID = value.OFFICIAL_FACULTY_ID
    const worksheet = workbook.addWorksheet(OFFICIAL_FACULTY_ID, {
      pageSetup: { paperSize: 'A4', showGridLines: false },
      // views: [{ state: "frozen", ySplit: 4 }],
    })

    worksheet.headerFooter.oddFooter = "หน้า &P จาก &N"

    let rowNum = 1
    let columnNum = 1

    worksheet.mergeCells(`A${rowNum}:I${rowNum}`)
    worksheet.getCell(`A${rowNum}`).alignment = middle_center
    worksheet.getCell(`A${rowNum++}`).value = `${value.FACULTY_NAME_TH}`

    // เริ่มวาดข้อมูลหัวตาราง-------------------------------------------------
    worksheet.getColumn(columnNum).width = 6
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "ลำดับ"

    worksheet.getColumn(columnNum).width = 15
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "รหัสนักศึกษา"

    worksheet.getColumn(columnNum).width = 15
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "คำนำหน้า"

    worksheet.getColumn(columnNum).width = 30
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "ชื่อ"

    worksheet.getColumn(columnNum).width = 30
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "นามสกุล"

    worksheet.getColumn(columnNum).width = 40
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "คณะ"

    worksheet.getColumn(columnNum).width = 60
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "สาขา"
    
    worksheet.getColumn(columnNum).width = 30
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "รหัสบัตรประชาชน"

    worksheet.getColumn(columnNum).width = 20
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "วันเดือนปีเกิด"

    rowNum = 3
    columnNum = 1
    value.data.map((data) => {
      // เริ่มวาดข้อมูล-------------------------------------------------
      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = rowNum - 2

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.student_id

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.t_prename

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.t_name

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.t_surname

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.faculty_name

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.curr2_tname

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.citizen_id

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.birth_date

      rowNum++
      columnNum = 1
    })

    worksheet.mergeCells(`A${rowNum}:I${rowNum}`)
    worksheet.getCell(`A${rowNum}`).alignment = middle_right
    const dateText = dayjs(value.created_at).locale('th').format('D MMM BBBB')
    worksheet.getCell(`A${rowNum++}`).value = `ข้อมูล ณ วันที่ ${dateText}`

  });

  const buffer = await workbook.xlsx.writeBuffer();
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  const fileExtension = ".xlsx"
  const blob = new Blob([buffer], { type: fileType })

  if (year !== 'ทั้งหมด') {
    year = `รหัส ${year} `;
  }
  saveAs(blob, `รายงานนักศึกษาระดับ` + level + `ที่มีสถานะเรียน` + year + fileExtension);
}

export const studentStudy = async (value, type) => {

  var text = '';
  if (type == 'disability') {
    text = 'ที่มีสถานะพิการ';
  } else if (type == 'islam') {
    text = 'ที่นับถือศาสนาอิสลาม';
  } else if (type == 'inter') {
    text = 'ต่างชาติ';
  }


  const common_format = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  }

  const middle_center = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  }

  const middle_left_no_wrap = {
    vertical: "middle",
    horizontal: "left"
  }

  // const middle_left = {
  //   vertical: "middle",
  //   horizontal: "left",
  //   wrapText: true
  // }

  const middle_right = {
    vertical: "middle",
    horizontal: "right",
    wrapText: true
  }

  const workbook = new ExcelJS.Workbook()
  workbook.creator = "Registrar KMITL"
  workbook.created = new Date()


    const worksheet = workbook.addWorksheet(`นักศึกษา${text}`, {
      pageSetup: { paperSize: 'A4', showGridLines: false },
      // views: [{ state: "frozen", ySplit: 4 }],
    })

    worksheet.headerFooter.oddFooter = "หน้า &P จาก &N"

    let rowNum = 1
    let columnNum = 1

    // เริ่มวาดข้อมูลหัวตาราง-------------------------------------------------
    worksheet.getColumn(columnNum).width = 6
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "ลำดับ"

    worksheet.getColumn(columnNum).width = 15
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "รหัสนักศึกษา"

    worksheet.getColumn(columnNum).width = 50
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "ชื่อ-นามสกุล"


    worksheet.getColumn(columnNum).width = 40
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "คณะ"

    worksheet.getColumn(columnNum).width = 80
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = "สาขา"
    
    if (type == 'disability') {
      worksheet.getColumn(columnNum).width = 60
      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = "ความพิการ"

      worksheet.getColumn(columnNum).width = 60
      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = "ความพิการ(อังกฤษ)"
    }

    if (type == 'inter') {
      worksheet.getColumn(columnNum).width = 20
      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = "สัญชาติ"

      worksheet.getColumn(columnNum).width = 20
      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = "ระดับการศึกษา"

      worksheet.getColumn(columnNum).width = 60
      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = "โรงเรียนที่จบการศึกษา"
    }

    rowNum = 2
    columnNum = 1
    
    value.map((data) => {
    
    // เริ่มวาดข้อมูล-------------------------------------------------
    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_center
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = rowNum - 1

    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = data.STUDENT_ID

    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = data.fullname

    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = data.FACULTY_NAME_TH

    worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
    worksheet.getRow(rowNum).getCell(columnNum).border = common_format
    worksheet.getRow(rowNum).getCell(columnNum++).value = data.curr2_tname

    if (type == 'disability') {
      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.DISABILITY_NAME_TH

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.DISABILITY_NAME_EN
    }

    if (type == 'inter') {
      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.RACE_NAME_EN

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.LEVEL

      worksheet.getRow(rowNum).getCell(columnNum).alignment = middle_left_no_wrap
      worksheet.getRow(rowNum).getCell(columnNum).border = common_format
      worksheet.getRow(rowNum).getCell(columnNum++).value = data.EDUCATION_NAME
    }

    rowNum++
    columnNum = 1
  })

  worksheet.mergeCells(`A${rowNum}:G${rowNum}`)
  worksheet.getCell(`A${rowNum}`).alignment = middle_right
  const dateText = dayjs(value.created_at).locale('th').format('D MMM BBBB')
  worksheet.getCell(`A${rowNum++}`).value = `ข้อมูล ณ วันที่ ${dateText}`

  const buffer = await workbook.xlsx.writeBuffer();
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  const fileExtension = ".xlsx"
  const blob = new Blob([buffer], { type: fileType })

  saveAs(blob, `รายงานนักศึกษา${text}` + fileExtension);
}